import { Component } from '@angular/core';
import { JoiAppData, canGoStraightToApp, codifyTitle } from 'globals/store/app.data';
import { MobileAppWrapper } from '../mobile.app.wrapper.component';
import { sleepForMS } from '../../../helpers/helpers';
import { MobileAppActions, mobileAppFeature } from '../mobile-store/mobile.app.era';
import { MobileLoginWrapperComponent } from './mobile-login-wrapper.component';
import { MobileLoginInputComponent } from './mobile-login-input.component';
import { JoiMessageComponent } from '../../cards/joi-message.component';
import { CommonModule } from '@angular/common';
import { takeUntil } from 'rxjs';

const ERROR_DISPLAY_MS = 3000
@Component({
    selector: 'mobile-login-app',
    template: `
<mobile-login-wrapper 
  [apps]="apps"
  [disabled]="!publishCode || loading" 
  (appsUpdated)="saveAppDatas($event)"
  (onButtonClick)="findApp(publishCode)">
  <div class="choose">Choose an event:</div>
  <mobile-login-input [label]="'Event app name'" [placeholder]="'Enter event app name'" [object]="this" [prop]="'publishCode'" [error]="error"></mobile-login-input>
  <div class="app-option-wrapper bottom" *ngFor="let appData of apps; first as first" [class.first]="first">
    <!--<delete-button [deleteTitle]="deleteTitle" [deleteText]="deleteText" [deleteButtonText]="'REMOVE'" (delete)="deleteApp(appData)"></delete-button>-->
    <div class="app-option bottom" (click)="goToApp(appData)">
      <div class="title">{{ appData.title }}</div>
    </div>
  </div>
</mobile-login-wrapper>
<joi-message *ngIf="appNotFound" [message]="'App not found'" (close)="hideAppNotFound()"></joi-message>

`,
    styles: [`
  :host { display: flex; position: relative; }
  mobile-login-input { margin: 5vh 0 0; }  
  .choose { color: white; font-size: 1.5em; margin: auto; font-weight: 100; margin-top: 1vh; }
  .app-option-wrapper { margin: 1.5vh auto 0.5vh; display: flex; align-items: center; position: relative; }
  .app-option-wrapper.first { margin-top: 4vh; }
  delete-button { color: white; position: absolute; left: -25px; }
  :host ::ng-deep delete-button icon { height: 18px; width: 18px; }
  .app-option { color: white; text-align: center; font-size: 1.25em; padding: 0.5vh 3vh;
    border-radius: 1.5vh; border: 1px solid var(--primary); width: fit-content; }
  joi-message { position: absolute; z-index: 100; width: 100%; }
`],
    standalone: true,
    imports: [MobileLoginWrapperComponent, MobileLoginInputComponent, JoiMessageComponent, CommonModule]
})
export class MobileFindAppComponent extends MobileAppWrapper<MobileFindAppComponent> {
  publishCode: string = ''
  error: string = ''
  loading = false
  apps: JoiAppData[] = []
  deleteTitle = 'Remove event'
  deleteText = 'Are you sure you want to remove this event from your phone?'
  appNotFound: boolean = false

  constructor() {
    super()
    this.loadApps()
    this.store.select(mobileAppFeature.selectNotFound).pipe(takeUntil(this.$destroy)).subscribe(appNotFound => {
      this.appNotFound = appNotFound || false;
    })
  }

  hideAppNotFound() {
    this.store.dispatch(MobileAppActions.setAppNotFound({ payload: false}))
  }

  async loadApps() {
    this.apps = await this.mobileAppService.loadAppDatas()
  }

  deleteApp(appData: JoiAppData) {
    this.apps = this.apps.filter(a => a.publishCode !== appData.publishCode)
    this.mobileAppService.saveAppDatas(this.apps)
  }

  saveAppDatas(appDatas: JoiAppData[]) {
    this.mobileAppService.saveAppDatas(appDatas)
    this.apps = appDatas
  }

  goToApp(appData: JoiAppData) {
    const canGoToApp = canGoStraightToApp(appData)
    // console.log({ appData, canGoToApp })
    if (canGoToApp) this.router.navigate(['app', appData.id])
    else this.router.navigate(['login', appData.publishCode])
  }

  async findApp(appTitle: string) { // passed in in case modified in flight
    const publishCode = codifyTitle(appTitle)
    try {
      const storedAppData = this.apps.find(a => a.publishCode === publishCode)
      if (storedAppData) {
        this.goToApp(storedAppData)
      } else {
        const appData = await this.mobileAppService.loadAppData(publishCode)
        if (!appData) {
          this.setError("Can't find that app.")
        } else {
          appData.publishCode = publishCode
          this.mobileAppService.saveAppData(appData)
          this.goToApp(appData)
        }
      }
    } catch (error) {
      console.error(error.error)
      this.setError(error.error)
    }
    
  }

  async setError(error) {
    this.error = error
    await sleepForMS(ERROR_DISPLAY_MS)
    this.error = ''
  }
}

